module.exports = "<hr>\n<h2>Alarms:</h2>\n<div class=\"filter\">\n  <h3>Filter by status</h3>\n  <park-filter (change)=\"setFilter($event)\" [filters]=\"filters\"></park-filter>\n</div>\n<park-alarms-item *ngFor=\"let alarm of sortedAlarms()\" [alarm]=\"alarm\">\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/alarms/park-alarms.html
// module id = ./src/app/dashboard/parks/park/alarms/park-alarms.html
// module chunks = main